import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const header = {
	elements: {
		$body: $(document.body),
		$openMenuButton: $('.js-open-menu-button'),
		$closeMenuButton: $('.js-close-menu-button'),
		$menu: $('.js-menu'),
		$menuLink: $('.js-menu-link'),
		$navigationLink: $('.js-navigation-link'),
	},

	selectors: {
		discoverSection: '.js-discover',
		arcSystemSection: '.js-arc-system',
		mapSection: '.js-map',
		faqSection: '.js-faq',
	},

	modifiers: {
		bodyLocked: 'body--locked',
		navigationLinkActive: 'navigation__link--active',
	},

	init() {
		this.initEvents()
		this.initAnimations();
	},

	initEvents() {
		this.elements.$openMenuButton.on('click', this.toggleMenu.bind(this, false))
		this.elements.$closeMenuButton.on('click', this.toggleMenu.bind(this, true))
		this.elements.$menuLink.on('click', this.toggleMenu.bind(this, true))
	},

	initAnimations() {
		const sections = [
			this.selectors.discoverSection,
			this.selectors.arcSystemSection,
			this.selectors.mapSection,
			this.selectors.faqSection,
		]

		sections.forEach(section => this.createSectionScrollTrigger(section))
	},

	createSectionScrollTrigger(section){
		const ID = $(section).attr('id')

		gsap.from(section, {
			scrollTrigger: {
				trigger: section,
				start: 'top 50%',
				end: 'bottom 50%',
				toggleActions: 'play reverse play reverse',
				onEnter: () => {
					this.handleSection(this.elements.$navigationLink, ID, true)
				},
				onEnterBack: () => {
					this.handleSection(this.elements.$navigationLink, ID, true)
				},
				onLeave: () => {
					this.handleSection(this.elements.$navigationLink, ID, false)
				},
				onLeaveBack: () => {
					this.handleSection(this.elements.$navigationLink, ID, false)
				},
			},
		})
	},

	handleSection($section, sectionID, show){
		$section
			.filter(`[data-id="#${sectionID}"]`)
			.toggleClass(this.modifiers.navigationLinkActive, show)
	},

	toggleMenu(hideMenu) {
		this.elements.$body.toggleClass(this.modifiers.bodyLocked, !hideMenu)
		this.elements.$menu.prop('inert', hideMenu)
		this.elements.$openMenuButton.toggle(hideMenu)
		this.elements.$closeMenuButton.toggle(!hideMenu)
	},
}

header.init()